module.exports = __webpack_public_path__ + "img/ae-gif-1.0a4b321.gif";